import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import i18next from 'i18next';
import Button from 'react-bootstrap-button-loader';
import styles from '../../../../styles/profile.module.css';
import * as storage from '../../../../utils/storage'

import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel'
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "@material-ui/core/TextField";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Popup } from "@progress/kendo-react-popup";
import { IntlProvider, LocalizationProvider } from '@progress/kendo-react-intl';
import moment from "moment";
import "moment/locale/fr";
import { loadLocalization } from '../../../../utils/kendoLocalization';
import { GetLanguage, IsEnglish } from '../../../../utils/language';
import Switch from '@material-ui/core/Switch'
import PhoneTextField from '../../../controls/PhoneTextField';
import AlertAlgo from '../../../controls/AlertSnack'
import * as StatusCode from '../../../../scripts/StatusCode';
import * as CommunicationPreference from '../../../../scripts/CommunicationPreference';

import { toPostalCode, cleanData, toEmpty, isEmpty, formatDate, toISOTimezone } from '../../../../utils';
import { getProvince, saveAddressProfile } from '../../../../actions/myFile/profile';

import { withNamespaces } from 'react-i18next';

loadLocalization();
moment.locale("fr");

const useStyles = makeStyles((theme) => ({
    rootProfile: {
        overflow: 'auto'
    },
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    divForm: {
        padding: '70px 10px 65px 10px',
        overflow: 'auto'
    },
    date: {
        marginBottom: '15px'
    },
    divButtons: {
        textAlign: 'center'
    }
}));

function AddressForm(props) {
    const classes = useStyles();

    const [data, setData] = useState([]);
    const [provinces, setProvinces] = useState([]);
    const [isMandatoryPhoneCellPerso, setIsMandatoryPhoneCellPerso] = useState(storage.getIsMandatoryPhoneCellPerso);
    const [isMandatoryEmailPerso, setIsMandatoryEmailPerso] = useState(storage.getIsMandatoryEmailPerso);
    const [isMandatorySMSPerso, setIsMandatorySMSPerso] = useState(storage.getIsMandatorySMSPerso);
    const [communicationPreference, setCommunicationPreference] = useState(storage.getCommunicationPreference);
    const [locale, setLocale] = useState(GetLanguage());

    const alertRef = useRef(null);

    useEffect(() => {
        loadProvinces();
        cleanFormatData();
        resize();
    }, []);

    useEffect(() => {
        if (data.address1 != undefined) {
            handleDataChanged();

            setIsMandatoryEmailPerso(isMandatoryEmailPerso || isEmpty(data.corporateEmail)
                || (communicationPreference == CommunicationPreference.EmailAndSMS || communicationPreference == CommunicationPreference.Email))
        }
    }, [data]);

    const cleanFormatData = () => {
        const formatData = props.data;
        formatData.personalPhone = cleanData(formatData.personalPhone);
        formatData.personalCellphone = cleanData(formatData.personalCellphone);
        // Initial effective date
        if (formatData.effectiveDate == null) {
            formatData.effectiveDate = new Date();
        }

        if (props.data.employeeChangeId != null && props.data.employeeChangeId > 0) {
            formatData.employeeChangeId = props.data.employeeChangeId;
        } else {
            formatData.employeeChangeId = 0;
        }

        setData(formatData)
    }

    const resize = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const menu = document.querySelector('#menuFavorite').clientHeight;
            const offSet = 50;

            const customHeight = height - titleBar - menu + offSet;

            const element = document.querySelector('#divAddress');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 0);
    }

    const handleClose = (isSaved) => {
        props.handleClose(true, isSaved);
    }

    const handleDataChanged = () => {
        props.handleDataChanged(isDataChanged(true));
    }

    const loadProvinces = () => {
        getProvince().then(response => {
            setProvinces(response);
        });
    }

    const isDataChanged = (isForceValidation = false) => {
        // We don't validate when is a pending address modification
        if (data.employeeChangeId > 0 && !isForceValidation) {
            return true;
        }

        const originalData = props.data;
        const stringOriginal = `${toEmpty(originalData.address1)}${toEmpty(originalData.address2)}${toEmpty(originalData.city)}
${toEmpty(originalData.province)}${toEmpty(originalData.postalCode)}
${toEmpty(originalData.personalPhone)}${toEmpty(originalData.personalCellphone)}
${toEmpty(originalData.personalEmail)}`;

        const stringNew = `${toEmpty(data.address1)}${toEmpty(data.address2)}${toEmpty(data.city)}
${toEmpty(data.province)}${toEmpty(data.postalCode)}
${toEmpty(data.personalPhone)}${toEmpty(data.personalCellphone)}
${toEmpty(data.personalEmail)}`;

        const isValid = stringOriginal != stringNew;

        return isValid;
    }

    const isValidData = () => {
        let message = '';

        if (isMandatoryPhoneCellPerso && isEmpty(data.personalPhone) && isEmpty(data.personalCellphone)) {
            message = i18next.t('profile:address.message.personalPhone-form');
        } else if ((isMandatorySMSPerso
                    || communicationPreference == CommunicationPreference.EmailAndSMS
                    || communicationPreference == CommunicationPreference.SMS)
                    && isEmpty(data.personalCellphone)) {
            message = i18next.t('profile:address.message.personalCellphone-form');
        } else if (isMandatoryEmailPerso && isEmpty(data.personalEmail)
            || isEmpty(data.personalEmail) && isEmpty(data.corporateEmail)
            || (communicationPreference == CommunicationPreference.EmailAndSMS
                || communicationPreference == CommunicationPreference.Email)
                && isEmpty(data.personalEmail) && isEmpty(data.corporateEmail)) {
            if ((communicationPreference == CommunicationPreference.EmailAndSMS
                || communicationPreference == CommunicationPreference.Email)) {
                message = i18next.t('profile:address.message.personalEmailPreferenceComm-form');
            } else {
                message = i18next.t('profile:address.message.personalEmail-form');
            }
        } else if (!isDataChanged()) {
            message = i18next.t('profile:message.noModification');
        }

        if (isEmpty(data.effectiveDate)) {
            message = i18next.t('profile:address.message.effectiveDate-form');
        } else if (isEmpty(data.address1)) {
            message = i18next.t('profile:address.message.street-form');
        } else if (isEmpty(data.city)) {
            message = i18next.t('profile:address.message.city-form');
        } else if (isEmpty(data.postalCode)) {
            message = i18next.t('profile:address.message.postalCode-form');
        }

        if (message.length > 0) {
            showMessageError(message);
            return false;
        }

        return true;
    }

    const handleSave = () => {
        if (isValidData()) {
            saveAddressProfile(data.employeeChangeId, data.effectiveDate, data.isImmediateChange, data.address1,
                data.address2, data.city, data.province, data.postalCode, cleanData(data.personalPhone), cleanData(data.personalCellphone),
                data.personalEmail, data.comment).then((response) => {
                    if (response != null && response.status != StatusCode.STATUS_OK) {
                        // Error
                        showMessageError(i18next.t('error:generic-error'));
                        return;
                    };

                    handleClose(true);
                })
        }
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const onDateChange = (event) => {
        setData({ ...data, effectiveDate: event.target.value });
    }

    const onChangeImmediateChange = (event) => {
        setData({ ...data, isImmediateChange: event.target.checked });
    }

    const onChangeStreet = (event) => {
        setData({ ...data, address1: event.target.value });
    }

    const onChangeStreet2 = (event) => {
        setData({ ...data, address2: event.target.value });
    }

    const onChangeProvince = (event) => {
        setData({ ...data, province: event.target.value });
    }

    const onChangeCity = (event) => {
        setData({ ...data, city: event.target.value });
    }

    const onChangePostalCode = (event) => {
        setData({ ...data, postalCode: toPostalCode(event.target.value) });
    }

    const onChangePersonalPhone = (event) => {
        setData({ ...data, personalPhone: event.target.value });
    }

    const onChangePersonalCellphone = (event) => {
        setData({ ...data, personalCellphone: event.target.value });
    }

    const onChangePersonalEmail = (event) => {
        setData({ ...data, personalEmail: event.target.value });
    }

    const onChangeComment = (event) => {
        setData({ ...data, comment: event.target.value });
    }

    let _el;

    return (
        <div id={"divAddress"} className={classes.divForm + ' ' + styles.rootProfile}>
            <LocalizationProvider language={locale}>
                <IntlProvider locale={locale}>
                    <FormControl className={classes.date} fullWidth ref={el => (_el = el)}>
                        <DatePicker
                            className={styles.inputDate + ' required'}
                            name="effectiveDate"
                            value={data.effectiveDate}
                            onChange={onDateChange}
                            format="yyyy-MM-dd"
                            disabled={data.isImmediateChange}
                            popup={props => <Popup {...props} appendTo={_el} />} />
                    </FormControl>

                    <FormControl className={styles.switchComponent} fullWidth>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={data.isImmediateChange || false}
                                    onChange={onChangeImmediateChange}
                                    name="partialLeave"
                                    variant="success"
                                />
                            }
                            label={i18next.t("profile:address.form.immediateChange")}
                            labelPlacement="start"
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField
                            id="street"
                            label={i18next.t('profile:list.street')}
                            value={data.address1 || ''}
                            onChange={onChangeStreet}
                            className={'required'}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField
                            id="complement"
                            label={i18next.t('profile:address.form.complement')}
                            value={data.address2 || ''}
                            onChange={onChangeStreet2}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField
                            id="city"
                            label={i18next.t('profile:list.city')}
                            value={data.city || ''}
                            onChange={onChangeCity}
                            className={'required'}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <div className={styles.divFormSelect}>
                            <InputLabel>{i18next.t('profile:list.province')}</InputLabel>
                            <Select
                                id="province"
                                value={data.province || ''}
                                onChange={onChangeProvince}
                            >
                                {provinces && provinces.map((obj, index) =>
                                    <MenuItem key={index} className={styles.selectItem} value={obj.value}>{IsEnglish() ? obj.descriptionE : obj.descriptionF}</MenuItem>
                                )}
                            </Select>
                        </div>
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField
                            id="postalCode"
                            label={i18next.t('profile:list.postalCode')}
                            value={data.postalCode || ''}
                            inputProps={{ maxLength: 7 }}
                            onChange={onChangePostalCode}
                            className={'required'}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <PhoneTextField
                            name="personalPhone"
                            id="personalPhone"
                            label={i18next.t('profile:list.personalPhone')}
                            value={data.personalPhone || ''}
                            placeholder="xxx xxx-xxxx"
                            handleChange={onChangePersonalPhone}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <PhoneTextField
                            name="personalCellphone"
                            id="personalCellphone"
                            label={i18next.t('profile:list.personalCellphone')}
                            value={data.personalCellphone || ''}
                            placeholder="xxx xxx-xxxx"
                            handleChange={onChangePersonalCellphone}
                            className={isMandatorySMSPerso === true ? 'required' : ''}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField
                            id="personalEmail"
                            label={i18next.t('profile:list.personalEmail')}
                            value={data.personalEmail || ''}
                            onChange={onChangePersonalEmail}
                            className={isMandatoryEmailPerso === true ? 'required' : ''}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField
                            id="comment"
                            label={i18next.t('profile:address.form.comment')}
                            value={data.comment || ''}
                            multiline
                            minRows={4}
                            onChange={onChangeComment}
                        />
                    </FormControl>
                    <FormControl fullWidth className="formDivButtons">
                        <div>
                            <Button className="saveButton" onClick={handleSave} variant="success">
                                {i18next.t('buttons:save')}
                            </Button>
                        </div>
                    </FormControl>
                </IntlProvider>
            </LocalizationProvider>
            <AlertAlgo ref={alertRef} />
        </div>
    );
}

export default withNamespaces(['Language', 'profile', 'buttons', 'error'], { wait: true })(AddressForm);